export default __webpack_public_path__ + "static/media/PRONTO.6325e126.png";